import { render, staticRenderFns } from "./CustomiseForm.vue?vue&type=template&id=0b520afd&scoped=true&"
import script from "./CustomiseForm.vue?vue&type=script&lang=ts&"
export * from "./CustomiseForm.vue?vue&type=script&lang=ts&"
import style0 from "./CustomiseForm.vue?vue&type=style&index=0&id=0b520afd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b520afd",
  null
  
)

export default component.exports